import store from '@/store'

/**
 * 配置工具类
 */
class ConfigUtil {
  /**
   * 获取配置信息
   * @param {string} key 配置键名
   * @returns {any} 配置值
   */
  static getConfig(key) {
    const config = store.state.config.config
    return key ? config[key] : config
  }

  /**
   * 获取邮箱配置
   * @returns {string} 邮箱配置
   */
  static site_mail() {
    return this.getConfig('site_mail')
  }

  /**
   * 获取手机配置
   * @returns {string} 手机配置
   */
  static site_mible() {
    return this.getConfig('site_mible')
  }
  /**
   * 获取关于我们图片
   * @returns {string} 关于我们图片
   */
  static about_us_img() {
    return this.getConfig('about_us_img')
  }
  /**
   * 获取关于我们文字
   * @returns {string} 关于我们文字
   */
  static about_us_text() {
    return this.getConfig('about_us_text')
  }
  /**
     * 获取热线
     * @returns {string} 热线
     */
    static hotline() {
      return this.getConfig('hotline')
    }
  /**
     * 获取小程序二维码
     * @returns {string} 小程序二维码
     */
    static mini_qrcode() {
      return this.getConfig('mini_qrcode')
    }
  /**
     * 获取支付银行
     * @returns {string} 支付银行
     */
    static pay_account() {
      return this.getConfig('pay_account')
    }
  /**
     * 获取支付支付宝
     * @returns {string} 支付支付宝
     */
    static pay_alipay() {
      return this.getConfig('pay_alipay')
    }
  /**
     * 获取支付银行
     * @returns {string} 支付银行
     */
    static pay_bank() {
      return this.getConfig('pay_bank')
    }
  /**
     * 获取支付帐户名
     * @returns {string} 支支付帐户名
     */
    static pay_bank() {
      return this.getConfig('pay_name')
    }
  /**
     * 获取微信公众号
     * @returns {string} 微信公众号
     */
    static wechat_qrcode() {
      return this.getConfig('wechat_qrcode')
    }
  /**
     * 获取工作时间
     * @returns {string} 工作时间
     */
    static work_time() {
      return this.getConfig('work_time')
    }

  /**
   * 初始化配置
   * @returns {Promise} 配置初始化Promise
   */
  static async initConfig() {
    try {
      await store.dispatch('getConfig')
      return true
    } catch (error) {
      console.error('初始化配置失败:', error)
      return false
    }
  }

  /**
   * 检查配置是否已加载
   * @returns {boolean} 是否已加载
   */
  static isConfigLoaded() {
    const config = store.state.config.config
    return config && Object.keys(config).length > 0
  }
}

export default ConfigUtil 